import { roles } from "../config/config";

export const medicalPermissions = [roles.admin, roles.gestore, roles.developer];

export const medicalMutationPermissions = [
  ...medicalPermissions,
  roles.agenteRoypet,
  roles.agenteRoydermal,
  roles.agenteCompleto,
  roles.agenteValderma,
].filter((role) => typeof role === "number");

export const centerMutationPermissions = [roles.admin, roles.gestore, roles.developer];

export const getMedicalPermissions = (userIsAgente) => [
  ...medicalPermissions,
  userIsAgente,
];
